module.exports = __webpack_public_path__ + "static/coaching-5cb1d3a10405a578eaf3c5b314f02ad2.png";